export default "ACSM-Konsensuspapier zu Bewegungsleitlinien für Krebsüberlebende – „Start low, go slow\" als Leitprinzip für sichere Bewegung in der Onkologie."